/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Publish_DescInputs */

const en_mk_nav_publish_desc = /** @type {(inputs: Mk_Nav_Publish_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview, release, and restore a previous version.`)
};

const id_mk_nav_publish_desc = /** @type {(inputs: Mk_Nav_Publish_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau, rilis, dan kembali ke versi lama.`)
};

/**
* | output |
* | --- |
* | "Preview, release, and restore a previous version." |
*
* @param {Mk_Nav_Publish_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_publish_desc = /** @type {((inputs?: Mk_Nav_Publish_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Publish_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_publish_desc(inputs)
	return en_mk_nav_publish_desc(inputs)
});